import RainbowLink from '@otovo/shared/components/RainbowLink/RainbowLink';
import { Sanity$TextMarkDefs } from '@otovo/shared/types/sanityTypes';
import { ReactNode, isValidElement } from 'react';

type Props = {
  mark: Sanity$TextMarkDefs;
  children:
    | string
    | null
    | undefined
    | Array<string>
    | ReactNode
    | Array<string | ReactNode>; // not certian that we can enforce string type
  className?: string;
};

function isBlankLink(mark) {
  return mark._type === 'link' && mark.target === '_blank';
}

function getRel(mark) {
  const blankLinkRel = 'noopener noreferrer';

  if (isBlankLink(mark)) {
    return [mark.rel, blankLinkRel].filter(Boolean).join(' ');
  }
  return mark.rel || undefined;
}

const SanityLink = ({ children, mark, className }: Props) => {
  const rel = getRel(mark);
  const target = isBlankLink(mark) ? mark.target : undefined;
  let linkSlug;

  if (mark._type === 'link') {
    linkSlug = mark.href;
  }

  if (!linkSlug) {
    // eslint-disable-next-line no-console
    console.warn('Link is not defined for node', { children, mark });
    return null;
  }

  if (typeof children === 'string') {
    return (
      <RainbowLink href={linkSlug} rel={rel} className={className}>
        {children}
      </RainbowLink>
    );
  }

  if (Array.isArray(children)) {
    const reactElement = children.find((child) => {
      return Array.isArray(child) && isValidElement(child[0]);
    });

    if (reactElement) {
      return (
        <RainbowLink href={linkSlug} rel={rel} className={className}>
          {reactElement}
        </RainbowLink>
      );
    }

    return (
      <RainbowLink
        href={linkSlug}
        rel={rel}
        target={target}
        className={className}
      >
        {children.reduce((acc, next) => `${acc} ${next}`, '')}
      </RainbowLink>
    );
  }

  // eslint-disable-next-line no-console
  console.warn('Expected children to be string or array, got', children);
  return null;
};

export default SanityLink;
